import { observable, action, computed, toJS } from 'mobx';
// import axios from 'axios'
import { request_post } from '../utils/utils';
// import api from '../utils/api'
import auth from '@root/service/auth-manager';
class commonStore {
  @observable userInfo = {};
  @observable orgTreeData = [];
  @observable planStatus = ['计划', '发布'];

  @action getUserInfo() {
    this.userInfo = auth._userInfo;
  }

  // 通用获取数据接口
  @action commonGetInterfaceData(url, params = {}) {
    return request_post(url, params).then((res) => {
      return Promise.resolve(res.data);
    });
  }

  @action setData(key, res, storeInstance, removeSpace = false) {
    let data = removeSpace ? res.replace(/(^\s*)|(\s*$)/g, '') : res;
    let keys = key.split('.');
    if (keys.length > 1) {
      for (let i in storeInstance) {
        if (i === keys[0]) {
          storeInstance[i][keys[1]] = data;
        }
      }
    } else {
      storeInstance[keys[0]] = data;
    }
  }

  /**
   *批量设置数据
   *
   * @param {*} obj 批量ke,val
   * @param {*} storeInstance store实例
   * @memberof commonStore
   */
  @action setDatas(obj, storeInstance) {
    let { setData } = new commonStore();
    let toString = Object.prototype.toString;
    if (toString.call(obj) !== '[object Array]' && typeof obj === 'object') {
      Object.keys(obj).forEach((key) => {
        setData(key, obj[key], storeInstance);
      });
    }
  }

  @computed get getSimpleTree() {
    let data = toJS(this.orgTreeData);
    return JSON.parse(
      JSON.stringify(data)
        .replace(/orgId/g, 'values')
        .replace(/orgName\b/g, 'label')
        .replace(/values/g, 'value')
        .replace(/childList/g, 'children')
    );
  }
}

export default new commonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.js